export default "__VITE_ASSET__DFfLMvNs__"